var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h4',[_vm._v(_vm._s(_vm.__('advances_to_be_cleared')))]),_vm._v(" "),_c('DataTable',{attrs:{"data":_vm.vatRates,"options":_vm.tableOptions,"summary":_vm.summary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }